import React, {useEffect, useState} from "react";
import {useTranslation} from "react-i18next";
import {registerLocale} from "react-datepicker";
import mn from "date-fns/locale/mn";

import './StatisticMain.css';
import {LuLoader2} from "react-icons/lu";
import MetaDataTable from "../../components/MetaDataTable";
import getBaseUrl from "../../helpers/http";
import {toast, ToastContainer} from "react-toastify";
import {Tree as TreeArborist} from "react-arborist";
import {FcFile, FcFolder, FcOpenedFolder} from "react-icons/fc";
import Skeleton from "../../components/Skeleton";
import JSTree from "../../components/JSTree";
import ReportHomeButton from "../../components/ReportHomeButton";
import TimeSeriesSection from "../../components/TimeSeriesSection";
import moment from "moment";

import $ from 'jquery';
import jsZip from 'jszip';
import 'datatables.net-buttons-dt';
import 'datatables.net-buttons/js/buttons.colVis.mjs';
import 'datatables.net-buttons/js/buttons.html5.mjs';
import 'datatables.net-fixedcolumns-dt';
import 'datatables.net-dt/css/jquery.dataTables.css';
import 'datatables.net-fixedcolumns-dt/css/fixedColumns.dataTables.css';
import SurveyTable from "../../components/SurveyTable";
import TradeBalanceChartModal from "../../components/TradeBalanceChartModal";

window.JSZip = jsZip;

registerLocale("mn", mn);
const StatisticMain = ({mainParentId, isSurvey, isReport, activeIndex}) => {

    const {t, i18n} = useTranslation();

    const [startDate, setStartDate] = useState(null);
    const [endDate, setEndDate] = useState(null);
    const [selectedFreq, setSelectedFreq] = useState();

    const [mainFetchError, setMainFetchError] = useState(-1);
    const [reportFetchError, setReportFetchError] = useState(-1);
    const [indicatorFetchError, setIndicatorFetchError] = useState(-1);
    const [metadataFetchError, setMetadataFetchError] = useState(-1);
    const [downloadFetchError, setDownloadFetchError] = useState(0);

    const [homeButtonList, setHomeButtonList] = useState();
    const [isCheck, setIsCheck] = useState(1);
    const [reportList, setReportList] = useState();
    const [indicatorList, setIndicatorList] = useState();
    const [metadataList, setMetadataList] = useState();
    const [selectedIndicator, setSelectedIndicator] = useState([]);
    const [activeMainReportId, setActiveMainReportId] = useState();
    const [activeMainReportName, setActiveMainReportName] = useState();
    const [activeReportId, setActiveReportId] = useState(null);
    const [activeReportName, setActiveReportName] = useState(null);
    const [cycleId, setCycleId] = useState(1);
    const [minDateReport, setMinDateReport] = useState();
    const [maxDateReport, setMaxDateReport] = useState();
    const [chartModalIsOpen, setChartModalIsOpen] = useState(false);


    const currentLang = i18n.language;

    const handleOptionChange = (value) => {
        setSelectedFreq(value);
    };

    const handleCheckboxChange = (event) => {
        setIsCheck(event.target.checked);
    };

    const setMain = (id, name) => {
        setActiveMainReportId(id)
        setActiveMainReportName(name)
        setActiveReportId(null)
        setIndicatorFetchError(-1)
    }

    const checkPeriod = (cycleid, fromYear) => {

        if (cycleid === '3') {
            return parseInt(fromYear) >= 2009;
        } else if (cycleid === '4') {
            return parseInt(fromYear) >= 1998;
        } else {
            return parseInt(fromYear) >= 1989;
        }

    }

    useEffect(() => {
        const parentId = mainParentId
        const fetchMain = async () => {
            setMainFetchError(-1)
            try {
                const mainResponse = await fetch(getBaseUrl()
                    + `report/main?lang=${currentLang}&parentId=${parentId}`, {
                    method: 'POST'
                });

                const mainResult = await mainResponse.json();

                if (mainResult.success) {
                    const firstMain = mainResult.result[0]
                    setMain(firstMain.id, firstMain.name)
                    setHomeButtonList(mainResult.result)
                    setMainFetchError(0);
                } else {
                    setMainFetchError(1);
                    toast.error(mainResult.result)
                }

                if (isSurvey === 1) {
                    const section = document.getElementById('survey');
                    if (section) {
                        section.scrollIntoView({behavior: 'smooth'});
                    }
                }

                if (isReport === 1) {
                    const section = document.getElementById('report');
                    if (section) {
                        section.scrollIntoView({behavior: 'smooth'});
                    }
                }

            } catch (error) {
                setMainFetchError(2);
                toast.error(t('report.errorCatch'))
                console.log('error 1', error);
            }

        };

        fetchMain().then()

    }, [activeIndex, currentLang, isSurvey, isReport, mainParentId, t]);

    useEffect(() => {
        const buildTree = (data, parentId = null) => {
            const tree = [];
            for (const node of data) {
                if (node.parent_id === parentId) {
                    const children = buildTree(data, parseInt(node.id));
                    if (children.length) {
                        node.children = children;
                    }
                    tree.push(node);
                }
            }
            return tree;
        }

        const fetchData = async () => {
            setReportFetchError(-1)
            try {
                const reportResponse = await fetch(getBaseUrl()
                    + `report/list?lang=${currentLang}&parentId=${activeMainReportId}`, {
                    method: 'POST'
                });

                const reportResult = await reportResponse.json();
                if (reportResult.success) {
                    const hierarchicalTreeData = buildTree(reportResult.result);
                    setReportList(hierarchicalTreeData)
                    setReportFetchError(0);
                } else {
                    setReportFetchError(1);
                    toast.error(reportResult.result)
                }
            } catch (error) {
                setReportFetchError(2);
                toast.error(t('report.errorCatch'))
                console.log('error 1', error);
            }

        };

        if (mainFetchError === 0)
            fetchData().then()

    }, [activeMainReportId, currentLang, mainFetchError, t])

    useEffect(() => {
        const fetchIndicator = async () => {
            setIndicatorFetchError(-1)
            setMetadataFetchError(-1)
            try {
                const indicatorResponse = await fetch(getBaseUrl()
                    + `indicator/list?lang=${currentLang}&reportId=${activeReportId}`, {
                    method: 'POST'
                });
                const indicatorResult = await indicatorResponse.json();
                if (indicatorResult.success) {
                    setIndicatorList(indicatorResult.result)
                    setIndicatorFetchError(0);
                } else {
                    setIndicatorFetchError(1);
                    toast.error(indicatorResult.result)
                }
            } catch (error) {
                setIndicatorFetchError(2);
                toast.error(t('report.errorCatch'))
                console.log('error 1', error);
            }

            try {
                const metadataResponse = await fetch(getBaseUrl()
                    + `metadata/data?lang=${currentLang}&reportId=${activeReportId}`, {
                    method: 'POST'
                });

                const metadataResult = await metadataResponse.json();
                if (metadataResult.success) {
                    setMetadataList(metadataResult.result[0])
                    setMetadataFetchError(0);
                } else {
                    setMetadataFetchError(1);
                }
            } catch (error) {
                setMetadataFetchError(2);
                toast.error(t('report.errorCatch'))
                console.log('error 1', error);
            }

        };

        if (activeReportId)
            fetchIndicator().then()


    }, [activeReportId, currentLang, t]);

    const treeListOnClick = (node) => {
        if (node.isLeaf) {
            setActiveReportId(node.data.id)
            setActiveReportName(node.data.name)
            setCycleId(node.data.cycle_id)
            setMinDateReport(node.data.mindate)
            setMaxDateReport(node.data.maxdate)
        } else {
            if (node.isOpen)
                node.close()
            else
                node.open()
        }
    }

    function NodeRenderer({node, style}) {
        let isActive = false;
        if (node.isLeaf && node.isSelected)
            isActive = true;
        return (
            <div style={style} className={"h-auto"}>
                <div
                    className={"flex flex-row gap-2 cursor-pointer" + (isActive ? " bg-gray-100 rounded " : "")}
                    onClick={() => treeListOnClick(node)}>
                    <div className={"my-auto"}>{node.isLeaf ?
                        <FcFile className={"my-auto"} size={"1.2em"}/>
                        : (node.isOpen ?
                            <FcOpenedFolder size={"1.2em"} className={"my-auto"}/> :
                            <FcFolder size={"1.2em"} className={"my-auto"}/>)}
                    </div>
                    <p>{node.data.name}</p>
                </div>
            </div>
        )
    }

    const downloadReport = async () => {

        if (downloadFetchError === -1)
            return

        if (downloadFetchError !== 0) {
            setDownloadFetchError(0)
            return
        }

        const mtS = moment(startDate)
        const mtE = moment(endDate)

        if (activeReportId === 1103 || activeReportId === 1104) {
            if (!checkPeriod(selectedFreq, mtS.format('yyyy'))) {
                toast(
                    <div className="flex flex-col text-sm text-center">
                        <div className={"font-bold"}>{t('finance.reportList.warningLine1')}</div>
                        <div>{t('finance.reportList.warningLine2')}</div>
                        <div>{t('finance.reportList.warningLine3')}</div>
                        <div>{t('finance.reportList.warningLine4')}</div>
                        <div>{t('finance.reportList.warningLine5')}</div>
                    </div>
                )
                return
            }
        }


        setDownloadFetchError(-1);

        const body = {
            id: activeReportId,
            parentId: mainParentId,
            rCheck: isCheck ? 1 : 0,
            cycle_data: {
                interval: selectedFreq,
                year_start: mtS.format('yyyy'),
                mq_start: selectedFreq === "4" ? mtS.format('Q') : mtS.format('M'),
                day_start: mtS.format('D'),
                year_end: mtE.format('yyyy'),
                mq_end: selectedFreq === "4" ? mtE.format('Q') : mtE.format('M'),
                day_end: mtE.format('D')
            },
            indicators: selectedIndicator
        }
        try {
            const downloadReportResponse = await fetch(getBaseUrl()
                + `indicator/data?lang=${currentLang}`, {
                method: 'POST',
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify(body)
            },);
            const downloadReportResult = await downloadReportResponse.json();
            if (downloadReportResult.success) {

                const data = downloadReportResult.result
                let cols = [];
                let name = null;

                const addTable = $('#add_table')
                addTable.empty()
                addTable.append('<table class="mx-0 w-full table-auto shadow-xl rounded-2xl reportDatatable hidden"><thead><tr class="report-th"></tr></thead><tbody></tbody></table>')
                let idx = 0;
                for (const k in data.report[0]) {
                    if (k === 'ID_T' || k === 'PARENT_ID_T' || k === 'INDICATOR_ID_D' || k === 'NAME_T' || k === 'LEVEL_T') {
                        continue
                    } else if (k === "NAME_T3") {
                        name = t('indicatorResult.tableName')
                    } else {
                        const n = k.replace(/'/g, '').split('#')
                        if (data.reporttype === 0) {
                            name = n[0]
                        } else {
                            if (n[1] === '1') {
                                name = `${n[0]} <sup>${t('indicatorResult.preName')}</sup>`
                            } else if (n[1] === '2') {
                                if (activeReportId === 1103 || activeReportId === 1104) {
                                    if (selectedFreq === 3) {
                                        name = `${n[0]} <sup>${t('indicatorResult.preName')}</sup>`
                                    } else {
                                        name = `${n[0]} <sup>${t('indicatorResult.newName')}</sup>`
                                    }
                                } else {
                                    name = `${n[0]} <sup>${t('indicatorResult.newName')}</sup>`
                                }
                            } else if (n[1] === '-1') {
                                name = `${n[0]} <sup>${t('indicatorResult.backcastedName')}</sup>`
                            } else {
                                if (data.cycleid === 1 && data.interval !== 1) {
                                    if (data.interval === 3) {
                                        n[0] = n[0].substring(0, 7)
                                    } else if (data.interval === 4) {
                                        const quarter = [0, 1, 1, 1, 2, 2, 2, 3, 3, 3, 4, 4, 4]
                                        let subStr

                                        if (n[0].substring(6, 7) === '0') subStr = 10
                                        else if (n[0].substring(6, 7) === '1' || n[0].substring(6, 7) === '2') {
                                            if (n[0].substring(5, 6) === '0') subStr = n[0].substring(6, 7)
                                            else subStr = n[0].substring(5, 7)
                                        } else subStr = n[0].substring(6, 7)
                                        n[0] = n[0].substring(0, 5) + quarter[subStr]
                                    } else n[0] = n[0].substring(0, 4)
                                }
                                name = `${n[0]} <sup>${t('indicatorResult.lastName')}</sup>`
                            }
                        }
                    }
                    $('.report-th').append('<th class="border-e border-b border-stone-300 p-2">' + k + '</th>')
                    cols.push({data: k, name: name, title: name, orderable: false, width: idx === 0 ? '300px' : ''})
                    idx++
                }

                const reportDataFromApi = data.report

                $('.reportDatatable').DataTable({
                    columns: cols,
                    ordering: false,
                    data: reportDataFromApi,
                    paging: false,
                    info: false,
                    destroy: true,
                    scrollY: 600,
                    scrollX: true,
                    scrollCollapse: true,
                    fixedColumns: {
                        leftColumns: 1,
                    },
                    searching: false,
                    columnDefs: [
                        {
                            targets: "_all", // Apply to all columns
                            createdCell: function (td) {
                                $(td).css('padding', '10px');
                            }
                        }
                    ],
                    dom: 'Bfrtip',
                    buttons: [
                        {
                            extend: 'excel',
                            text: 'Export to Excel',
                            title: activeReportName,
                            filename: (activeMainReportName + ' - '
                                + activeReportName + '_'
                                + moment(startDate).format('YYYY-MM-DD') + '_'
                                + moment(endDate).format('YYYY-MM-DD')),
                        }
                    ],
                }).buttons(0).trigger()

                setDownloadFetchError(0);
            } else {
                setDownloadFetchError(1);
                toast.error(downloadReportResult.result)
            }
        } catch (error) {
            setDownloadFetchError(2);
            toast.error(t('report.errorCatch'))
            console.log('error 1', error);
        }
    }

    return (
        <>
            <ToastContainer
                position="top-right"
                autoClose={5000}
                hideProgressBar={false}
                newestOnTop={false}
                closeOnClick
                rtl={false}
                pauseOnFocusLoss
                draggable
                pauseOnHover
                theme="light"
            />

            <img
                src="/images/finance-banner.webp"
                className={"w-full hidden sm:block"}
                alt="finance-banner"/>

            <div className={"container mx-auto relative bottom-0 sm:bottom-5 md:bottom-10 lg:bottom-20"}>
                <div className={"grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10"}>
                    {mainFetchError === 0 ?
                        <ReportHomeButton data={homeButtonList} activeMainReportId={activeMainReportId}
                                          setMain={setMain}/> :
                        <Skeleton type={"financeHomeButtonLoader"} i={8}/>}
                </div>
            </div>

            <div
                id="report" className={"container mx-auto mt-8 md:mt-0"}>
                <p className={"text-2xl font-bold border-b-2 border-gray-300 pb-8 mb-6"}>{activeMainReportName}</p>
            </div>

            <div
                className={"container mx-auto mt-2 " + (downloadFetchError === -1 ? " cursor-progress hover:cursor-progress " : " ")}>
                <div className={"grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4"}>
                    <div className="col-span-2 lg:col-span-1 bg-white rounded-[9px] shadow p-4">
                        <div className={"flex flex-col"}>
                            <div className={"border-b-2 pt-2 pb-4 px-3"}>
                                <p className={"text-xl text-[#163578] font-bold"}>{t('finance.reportList.report')}</p>
                            </div>
                            <div className={"flex flex-row overflow-y-auto h-80 w-full ps-0 tree-parent"}>
                                {reportFetchError === 0
                                    ? <TreeArborist
                                        className="react-aborist"
                                        data={reportList}
                                        indent={25}
                                        rowHeight={50}
                                        padding={20}
                                        openByDefault={false}
                                        width={"100%"}>{NodeRenderer}</TreeArborist>
                                    : <div className="flex flex-row justify-center w-full">
                                        <LuLoader2 size={"4em"} color={"#163578"} className={"m-auto animate-spin"}/>
                                    </div>}
                            </div>
                        </div>
                    </div>
                    <div className="col-span-2 bg-white rounded-[9px] shadow p-4">
                        <div className={"flex flex-col"}>
                            <div className={"border-b-2 pt-2 pb-4 px-3"}>
                                <p className={"text-xl text-[#163578] font-bold"}>{t('finance.reportList.indicator')}</p>
                            </div>
                            <div className={"flex flex-row overflow-y-scroll h-80 ps-3"}>
                                {indicatorFetchError === 0
                                    ? <JSTree data={indicatorList} setSelectedIds={setSelectedIndicator}/>
                                    : (activeReportId ? <div className="flex flex-row justify-center w-full">
                                            <LuLoader2 size={"4em"} color={"#163578"} className={"m-auto animate-spin"}/>
                                        </div>
                                        : <div className="flex flex-row justify-center w-full">
                                            <p className={"text-lg m-auto text-stone-400"}>{t('finance.chooseReport')}</p>
                                        </div>)}
                            </div>
                        </div>
                    </div>
                    <div className="col-span-2 lg:col-span-1 bg-white rounded-[9px] shadow p-4">
                        <div className={"flex flex-col"}>
                            <div className={"border-b-2 pt-2 pb-4 px-3"}>
                                <p className={"text-xl text-[#163578] font-bold"}>{t('finance.reportList.series')}</p>
                            </div>
                            <TimeSeriesSection
                                selectedFreq={selectedFreq}
                                startDate={startDate}
                                setStartDate={setStartDate}
                                endDate={endDate}
                                setEndDate={setEndDate}
                                activeMainReportId={activeMainReportId}
                                activeReportId={activeReportId}
                                selectedIndicator={selectedIndicator}
                                currentLang={currentLang}
                                minDateReport={minDateReport}
                                maxDateReport={maxDateReport}
                                downloadReport={downloadReport}
                                handleOptionChange={handleOptionChange}
                                cycleId={cycleId}
                                downloadFetchError={downloadFetchError}
                                isCheck={isCheck}
                                handleCheckboxChange={handleCheckboxChange}
                                showChartButton={mainParentId === 20 && Number(activeReportId) === 1103}
                                onOpenChart={() => setChartModalIsOpen(true)}
                            />
                        </div>
                    </div>
                </div>
            </div>

            <div id="add_table" className={"invisible"}>
            </div>
            {metadataFetchError !== -1 ?
                <div className={"container mx-auto my-10"}>
                    <p className={"text-2xl font-bold border-b-2 border-gray-300 pb-8 mb-6"}>{t('finance.metaTitle')}</p>
                    <div className={"overflow-x-auto rounded-2xl shadow-xl"}>
                        <MetaDataTable data={metadataList} ind={metadataFetchError}/>
                    </div>
                </div> : ""}
            {/*    : (activeReportId ? <div className="flex flex-row justify-center w-full p-10">*/}
            {/*    <LuLoader2 size={"4em"} color={"#163578"} className={"m-auto animate-spin"}/>*/}
            {/*</div> : <div className="flex flex-row justify-center w-full p-10">*/}
            {/*    <p className={"text-lg m-auto text-black"}>{t('finance.chooseReport')}</p>*/}
            {/*</div>)}*/}

            <div id="survey" className={"container mx-auto mt-5 mb-20"}>
                {/*<p className={"text-2xl font-bold border-b-2 border-gray-300 pb-8 mb-6"}>{t('surveyTable.mainTitle')}</p>*/}
                <SurveyTable parentId={mainParentId}/></div>
            <TradeBalanceChartModal
                isOpen={chartModalIsOpen}
                onRequestClose={() => setChartModalIsOpen(false)}
            />
        </>
    );
};

export default StatisticMain;
